module.exports = __webpack_public_path__ + "static/media/CV_Mikhail Zyryanov.85adc1d1.pdf";